import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { KindOfOrder } from '../../../../types/enums';
import { MessageThread } from '../types/MessageThread';

export const useGetMessageThread = (notificationQueueID: number | undefined,
    orderID: number, kindOfOrder: KindOfOrder) => {

    const { data, isLoading } = useQuery({
        queryKey: ['message-thread', notificationQueueID, orderID, kindOfOrder],
        enabled: !!notificationQueueID,
        queryFn: async () => await apiClient.get('communication/message-thread',
            {
                params:
                {
                    notificationQueueID: notificationQueueID,
                    orderID: orderID,
                    kindOfOrder: kindOfOrder
                }
            }) as MessageThread
    });

    return {
        data,
        isLoading
    };
};
